var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { node } from 'prop-types';
import Dialog from '../../Dialog';
var StyledBottomSheet = styled(Dialog)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  align-self: flex-end;\n  animation: content;\n  animation-duration: 400ms;\n  animation-fill-mode: forwards;\n  @keyframes content {\n    0% {\n      transform: translateY(100vh);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n"])), function (_ref) {
  var bottomsheet = _ref.theme.yoga.components.bottomsheet;
  return "\n  padding: " + bottomsheet.padding.top + "px " + bottomsheet.padding.right + "px " + bottomsheet.padding.bottom + "px " + bottomsheet.padding.left + "px;\n  width: " + bottomsheet.width["default"] + "%;\n  border-radius: " + bottomsheet.border.radius + "px " + bottomsheet.border.radius + "px 0 0;\n  ";
});

var BottomSheet = function BottomSheet(props) {
  return /*#__PURE__*/React.createElement(StyledBottomSheet, _extends({
    hideCloseButton: true
  }, props));
};

BottomSheet.propTypes = {
  children: node.isRequired
};
export default BottomSheet;